export default __webpack_public_path__ + "static/found-88ba77592e8609b8539eb490a5745674.jpg";